import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import { copyToClipboard } from '../../../../util/copy-to-clipboard'
import currentUserHasAccess from '../../../../util/widget-helper'
import { ALIGNER_LABEL_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const AlignerLabelInput = ({ text }) => {
    if (!text) {
        return null
    }
    return (
        <div className="input-group">
            <input readOnly={true} className="form-control" value={text}/>
            <span className="input-group-btn">
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        copyToClipboard(text)
                    }}>
                    <i className="fa fa-copy"/>
                </button>
            </span>
        </div>)
}

const AlignerLabel = ({ salesOrder, alignerLabelList, readOnly }) => {
    if (!currentUserHasAccess(ALIGNER_LABEL_WIDGET_CONTAINER)) {
        return null
    }

    const referenceNumberPartList = salesOrder.referenceNumber.split('-')

    const renderAlignerLabel = (label) => {
        return label ? referenceNumberPartList[2] + label : ''
    }

    return (
        <ContentBox title="Aligner Label">
            <table className="default-table">
                <thead>
                    <tr>
                        <th>Upper</th>
                        <th>Lower</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        alignerLabelList.map((label, index) => {
                            const upperText = renderAlignerLabel(label.upper)
                            const lowerText = renderAlignerLabel(label.lower)
                            return (
                                <tr key={index}>
                                    <td><AlignerLabelInput text={upperText}/></td>
                                    <td><AlignerLabelInput text={lowerText}/></td>
                                </tr>)
                        })
                    }
                </tbody>
            </table>
        </ContentBox>
    )
}

AlignerLabel.propTypes = {
    readOnly: PropTypes.bool,
    salesOrder: PropTypes.object.isRequired,
}

export default AlignerLabel



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/AlignerLabel.js